import setLaterSuitabilityState from './setLaterSuitabilityState'
import setSpendPrefundAmount from './setSpendPrefundAmount'
import updateSignaturePoints from './updateSignaturePoints'

const resolvers = {
  setLaterSuitabilityState,
  updateSignaturePoints,
  setSpendPrefundAmount,
}

export default resolvers
